module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      'coder-wrapper': true, 'hasError': this.hasError
    }
  }, [_c('div', {
    staticClass: "coder-v-line"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.hasError),
      expression: "!this.hasError"
    }],
    staticClass: "coder-v-js"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.codes), function(code, key) {
    return _c('div', {
      staticClass: "coder-row",
      class: {
        'error': code.errors,
          'active': code.active
      }
    }, [_c('div', {
      staticClass: "coder-content-box layout-fw"
    }, [_c('div', {
      staticClass: "coder-line"
    }, [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('div', {
      staticClass: "coder-content"
    }, [_c('div', {
      staticClass: "coder-js"
    }, [_c('input', {
      directives: [{
        name: "focus",
        rawName: "v-focus",
        value: (_vm.focusMe('script', key)),
        expression: "focusMe('script', key)"
      }, {
        name: "model",
        rawName: "v-model",
        value: (code.script),
        expression: "code.script"
      }],
      domProps: {
        "value": (code.script)
      },
      on: {
        "click": function($event) {
          _vm.setFocusCursor('script', key)
        },
        "focus": function($event) {
          _vm.setFocusCursor('script', key)
        },
        "keyup": function (evt) {
          _vm.keyUP({
            evt: evt,
            code: code,
            member: 'script',
            index: key
          });
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(code, "script", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "coder-reason"
    }, [_c('input', {
      directives: [{
        name: "focus",
        rawName: "v-focus",
        value: (_vm.focusMe('explanation', key)),
        expression: "focusMe('explanation', key)"
      }, {
        name: "model",
        rawName: "v-model",
        value: (code.explanation),
        expression: "code.explanation"
      }],
      domProps: {
        "value": (code.explanation)
      },
      on: {
        "click": function($event) {
          _vm.setFocusCursor('explanation', key)
        },
        "focus": function($event) {
          _vm.setFocusCursor('explanation', key)
        },
        "keyup": function (evt) {
          _vm.keyUP({
            evt: evt,
            code: code,
            member: 'explanation',
            index: key
          });
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(code, "explanation", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _vm._l((code.errors), function(err) {
      return (code.errors) ? _c('div', {
        staticClass: "coder-content-box layout-fw"
      }, [_c('div', {
        staticClass: "coder-line"
      }), _vm._v(" "), _c('div', {
        staticClass: "coder-content error-msg"
      }, [_vm._v("\n            " + _vm._s(err.msg) + "\n          ")])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "color-line-border layout-fw"
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "coder-console"
  }, [_c('h1', {
    staticClass: "console-title"
  }, [_vm._v("Console")]), _vm._v(" "), _vm._l((_vm.logs), function(item, key) {
    return _c('div', {
      staticClass: "console-row",
      on: {
        "mouseenter": function($event) {
          _vm.highlightAtLine(item.line)
        },
        "mouseleave": function($event) {
          _vm.cancelHighLightAtLine(item.line)
        }
      }
    }, [_vm._v("\n          Line " + _vm._s(item.line) + ":\n          "), _vm._l((item.args), function(arg, key) {
      return _c('span', {
        staticClass: "console-arg"
      }, [_vm._v(_vm._s(JSON.stringify(arg)) + " " + _vm._s(key < (item.length - 1) ? ', ' : ''))])
    })], 2)
  })], 2)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coder-row"
  }, [_c('div', {
    staticClass: "coder-content-box layout-fw"
  }, [_c('div', {
    staticClass: "coder-line"
  }, [_vm._v("Line")]), _vm._v(" "), _c('div', {
    staticClass: "coder-content"
  }, [_c('div', {
    staticClass: "coder-js"
  }, [_vm._v("JavaScript")]), _vm._v(" "), _c('div', {
    staticClass: "coder-reason"
  }, [_vm._v("Explanation")])])]), _vm._v(" "), _c('div', {
    staticClass: "color-line-border layout-fw"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-510c8bda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Archive/Coder.vue
// module id = 301
// module chunks = 3